import { render, staticRenderFns } from "./CompanyAdditionalInfo.vue?vue&type=template&id=fef44266&"
import script from "./CompanyAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports